var exports = {
  "kL": "TextToSpeech.module__container___WXE4R1",
  "$J": "TextToSpeech.module__linkButton___WXE4R1",
  "h3": "TextToSpeech.module__helperCallout___WXE4R1",
  "E$": "TextToSpeech.module__helperIcon___WXE4R1",
  "cy": "TextToSpeech.module__helperText___WXE4R1",
  "Cc": "TextToSpeech.module__narrationSection___WXE4R1",
  "qE": "TextToSpeech.module__narrationHeader___WXE4R1",
  "hC": "TextToSpeech.module__narrationTitle___WXE4R1",
  "Hb": "TextToSpeech.module__narrationDescription___WXE4R1",
};

module.exports = exports;
